export class Notification {
  constructor(
    public id: number,
    public recipientId: number,
    public recipientEmail: string,
    public type: string,
    public title: string,
    public message: string,
    public relatedGroupId: number | null,
    public relatedGroupName: string | null,
    public isRead: boolean,
    public createdAt: string,
    public actionUrl: string | null,
  ) {}
}
